import React, {Fragment, FunctionComponent, useState} from "react";

type MileageInputProps = {
    id?: string
    value: number
    placeholder?: string
    onChange: (event: number) => void
    onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void
    className?: string
    autoFocus?: boolean
    validationMessage?: string
}

export const MileageInput: FunctionComponent<MileageInputProps> = (props: MileageInputProps) => {

    const addSep = (num) => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    const removeNonNumeric = (num) => num.toString().replace(/[^0-9]/g, "");

    const [formattedMileage, setFormattedMileage] = useState(addSep(removeNonNumeric(props.value || '')))


    const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        setFormattedMileage(addSep(removeNonNumeric(e.target.value)))
        props.onChange(parseInt(removeNonNumeric(e.target.value)))
    }

    return (
        <Fragment>
            <div className={`relative ${props.className}`}>
                <input
                    id="mileage"
                    name="mileage"
                    className="w-full py-2 px-3 my-2 border border-neutral-500 rounded-md shadow"
                    placeholder={props.placeholder}
                    value={formattedMileage ?? ''}
                    autoFocus={props.autoFocus}
                    onChange={handleChange}
                    onKeyDown={props.onKeyDown}/>
                <span
                    className="h-full absolute text-center text-slate-300 absolute rounded inline-flex items-center justify-center right-0 p-3">
                    KM
                </span>
            </div>
            {props.validationMessage && (
                <p className="mt-1 mb-4 text-sm text-error-600" id={`${props.id}-error`}>
                    {props.validationMessage}
                </p>
            )}
        </Fragment>
    )
}
